import useSWR from 'swr';
import * as P from '@/lib/portal/service';

// user id → display name for a project (internal managers + external members), email fallback, id-prefix fallback
export function useNames(projectId) {
  const { data } = useSWR(projectId ? ['people', projectId] : null, () => P.people(projectId), { dedupingInterval: 60000 });
  const map = Object.fromEntries((data || []).map((p) => [p.user_id, p.display_name || p.email || '']));
  return (id) => (id ? map[id] || `user ${String(id).slice(0, 8)}` : '—');
}
